import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Login from "./Login/Login";
import "./App.css";
import { Error } from "./Generic/404";
import MachineRoute from "./Routing/MachineRoute";
import MachineSelect from "./Landing/MachineSelect";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import TaskManager from "./RepenishmentPlanManager/taskManager";
import PastTasks from "./RepenishmentPlanManager/pastTasks";
import CreateInventoryPlan from "./InventoryPlan/createInventoryPlan";
import InventoryPlanList from "./InventoryPlan/InventoryPlanList";
import InventoryPlanDetails from "./InventoryPlan/inventoryPlanDetails";
import EditInventoryPlan from "./InventoryPlan/editInventoryPlan";
import { SuperTokensWrapper } from "supertokens-auth-react";
import { getSuperTokensRoutesForReactRouterDom } from "supertokens-auth-react/ui";
import { PasswordlessPreBuiltUI } from "supertokens-auth-react/recipe/passwordless/prebuiltui";
import * as reactRouterDom from "react-router-dom";
import { SessionAuth } from "supertokens-auth-react/recipe/session";
import SuperTokensService from "./auth/supertokens";
import AppLayout from "./Layout/AppLayout";
import AuthorizedRoute from "./Routing/AuthorizedRoute";
import CurrentInventory from "./InventoryPlan/currentInventory";

SuperTokensService.initialise();

function App() {

	const location = useLocation();

	return (
		<SuperTokensWrapper>
			<div className="App">
				<ToastContainer limit={3} isMobile breakpoint="600" />
				{/* CSSTransition for animation between parent routes */}
				<SwitchTransition>
					<CSSTransition
						//To animate only the parent routes and not the nested routes
						key={location.pathname.split("/")[1]}
						timeout={300}
						classNames="page"
						unmountOnExit>
						<Routes location={location} static>
							{/* Routes without auth */}

							<Route path="*" element={<Error />} />

							<Route path="/404" element={<Error />} />

							{/* <Route path="/login" element={<Login />} /> */}

							{getSuperTokensRoutesForReactRouterDom(reactRouterDom, [PasswordlessPreBuiltUI])}

							{/* Routes that don't need Header or Sidebar */}

							<Route
								path=""
								element={
									<SessionAuth>
										{/*Components that require to be protected by authentication*/}
										<AppLayout>
											<AuthorizedRoute>
											<MachineSelect />
											</AuthorizedRoute>
										</AppLayout>
									</SessionAuth>
								}
								exact
							/>

							<Route
								path="/:id/*"
								element={
									<SessionAuth>
										<AuthorizedRoute>
											{/*Components that require to be protected by authentication*/}
											<MachineRoute end />
										</AuthorizedRoute>
									</SessionAuth>
								}>
								<Route path="" element={<TaskManager />} exact />

								<Route path="task/history" element={<PastTasks />} exact />

								<Route path="inventoryPlan/create" element={<CreateInventoryPlan />} exact />

								<Route path="inventoryPlan/currentInventory" element={<CurrentInventory />} exact />

								<Route path="inventoryPlan/list" element={<InventoryPlanList />} exact />

								<Route path="inventoryPlan/details/:id" element={<InventoryPlanDetails />} exact />

								<Route path="inventoryPlan/edit/:id" element={<EditInventoryPlan />} exact />

								<Route path="*" element={<Error />} />
							</Route>
						</Routes>
					</CSSTransition>
				</SwitchTransition>
			</div>
		</SuperTokensWrapper>
	);
}

export default App;
